module.exports = __webpack_public_path__ + "img/AbdulqadirSaed-Byaban.76907dc1.jpg";